import { onBeforeMount, onBeforeUnmount } from 'vue'

/**
 * 画面をクリックした際のイベント駆動
 * モーダルやアコーディオンメニュー等の開閉コントロール系のコンポーネントにおいて、
 * 開いている状態でコンポーネント外のエリアをクリックした際のコンポーネントを閉じる処理をハンドリング
 *
 * @param callback backdrop クリックで発火する callback 関数
 * @param backdropCancelId 自要素がクリックされた際の、backdrop の callback 処理発火防止用の識別 ID。コンポーネントのルートエレメントに「data-backdrop-cancel」の属性値で id 値を指定
 */
export default function(callback: Callback, backdropCancelId: string) {
  const listener = (e: Event) => {
    if (!(e.target instanceof HTMLElement)) {
      return
    }

    if (!e.target.closest(`[data-backdrop-cancel="${backdropCancelId}"]`)) {
      callback()
    }
  }

  onBeforeMount(() => {
    document.addEventListener('click', listener)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('click', listener)
  })
}
